import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import axios from '../axios';
import ModalAlert from '../modal/modal_alert';

const Questions = ({ rurl }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonValid, setIsButtonValid] = useState(false);
  const [familyname, setFamilyname] = useState('');
  const [firstname, setFirstname] = useState('');
  const [gender, setGender] = useState('');
  const [birthdate, setBirthdate] = useState('');
  const [isFamilynameRegistrated, setIsFamilynameRegistrated] = useState(false);
  const [isFirstnameRegistrated, setIsFirstnameRegistrated] = useState(false);
  const [isGenderRegistrated, setIsGenderRegistrated] = useState(false);
  const [isBirthdateRegistrated, setIsBirthdateRegistrated] = useState(false);
  const [isVerifiedIdentity, setIsVerifiedIdentity] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const modalAlertCompleteRef = useRef(null);

  const redirectToFunc = useCallback(() => {
    if (rurl) {
      location.href = rurl;
    } else {
      location.reload();
    }
  }, [rurl]);

  useEffect(() => {
    axios.get('/api/questions/data').then((res) => {
      const data = res.data;
      if (data) {
        setFamilyname(data.currentUser.familyname || '');
        setFirstname(data.currentUser.firstname || '');
        setGender(data.currentUser.gender || '');
        setBirthdate(data.currentUser.birthdate ? moment(data.currentUser.birthdate).format('YYYY-MM-DD') : '');
        setIsGenderRegistrated(data.currentUser.gender ? true : false)
        setIsBirthdateRegistrated(data.currentUser.birthdate ? true : false)
        setIsFamilynameRegistrated(data.currentUser.familyname ? true : false)
        setIsFirstnameRegistrated(data.currentUser.firstname ? true : false)
        setIsVerifiedIdentity(data.currentUser.is_verified_identity)
        setIsLoading(false);
      }
    });
  }, [setFamilyname, setFirstname, setIsLoading]);

  useEffect(() => {
    const isValid =
      familyname !== '' && firstname !== '' && gender !== '' && birthdate !== '' ? true : false;
    setIsButtonValid(isValid);
  }, [familyname, firstname, setIsButtonValid, gender, birthdate]);

  const submitFunc = useCallback(() => {
    const data = isVerifiedIdentity || (isFamilynameRegistrated && isFirstnameRegistrated)  ?
    {
      user: {
        gender: gender,
        birthdate: birthdate,
        is_gender_public: true,
        is_birthdate_public: true,
      },
    } : {
      user: {
        familyname: familyname,
        firstname: firstname,
        gender: gender,
        birthdate: birthdate,
        is_gender_public: true,
        is_birthdate_public: true,
      },
    }
    axios
      .patch('/api/user', data)
      .then(() => {
        setIsSuccess(true);
      })
      .catch(() => {
        setIsSuccess(false);
      })
      .finally(() => {
        modalAlertCompleteRef.current.openModal();
      });
  }, [familyname, firstname, gender, birthdate]);

  return isLoading ? null : (
    <React.Fragment>
      <h6 className="text-fw-bold text-center mb-3_5">
        ご利用にはユーザー情報登録が必要です
      </h6>
      <div>
        <ul className="nav flex-column">
          {!isVerifiedIdentity && (
            <div>
              {!isFamilynameRegistrated && (
                <li className="nav-item p-3 border-bottom">
                  <div className="row">
                    <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                      姓
                    </div>
                    <div className="col-8">
                      <input
                        type="text"
                        className="form-control"
                        style={{ border: "none", backgroundColor: "#f5f5f5" }}
                        onChange={(e) => setFamilyname(e.target.value)}
                        value={familyname} />
                    </div>
                  </div>
                </li>
              )}
              {!isFirstnameRegistrated && (
                <li className="nav-item p-3 border-bottom">
                  <div className="row">
                    <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                      名
                    </div>
                    <div className="col-8">
                      <input
                        type="text"
                        className="form-control"
                        style={{ border: "none", backgroundColor: "#f5f5f5" }}
                        onChange={(e) => setFirstname(e.target.value)}
                        value={firstname} />
                    </div>
                  </div>
                </li>
              )}
            </div>
          )}
          <li className="nav-item p-3 border-bottom">
            <div className="row">
              <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                性別
              </div>
              <div className="col-8">
                {isGenderRegistrated ? (
                  <div className="text-fz-16px">
                    <p className="mb-0">{gender === 'male' ? '男性' : '女性'}</p>
                  </div>
                ) : (
                  <select
                    className="form-control"
                    style={{ display: "inline-block", border: "none", backgroundColor: "#f5f5f5" }}
                    name="gender"
                    id="gender"
                    onChange={(e) => setGender(e.target.value)}
                    value={gender}
                    readOnly={isGenderRegistrated}
                  >
                    <option value="male" selected={isGenderRegistrated && gender === 'male'} disabled={isGenderRegistrated && gender !== 'male'}>男性</option>
                    <option value="female" selected={isGenderRegistrated && gender === 'female'} disabled={isGenderRegistrated && gender !== 'female'}>女性</option>
                  </select>
                )}
                <p className="p-0 mb-0 text-fz-small">
                  ※ 性別が表示されます。
                </p>
              </div>
            </div>
          </li>
          <li className="nav-item p-3 border-bottom">
            <div className="row">
              <div className="col-4" style={{ height: "25px", opacity: "0.7" }}>
                生年月日
              </div>
              <div className="col-8">
                {isBirthdateRegistrated ? (
                  <div className="text-fz-16px">
                    <p className="mb-0">{moment(birthdate).format('YYYY-MM-DD')}</p>
                  </div>
                ) : (
                  <input
                    type="date"
                    className="datetimepicker form-control"
                    style={{ display: "inline-block", border: "none", backgroundColor: "#f5f5f5" }}
                    id="birthdate"
                    defaultValue={birthdate}
                    onChange={(e) =>
                      setBirthdate(moment(e.target.value).format('YYYY-MM-DD'))
                    }
                    autoComplete="off"
                    disabled={isBirthdateRegistrated}
                  />
                )}
                <p className="p-0 mb-0 text-fz-small">
                  ※ 生年月日から計算した年齢が表示されます。
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="container pt-3">
        <div className="d-flex">
          <button
            className='a-button a-button__top a-button--orange width-full mx-auto'
            onClick={() => submitFunc()}
            disabled={!isButtonValid}
          >
            登録する
          </button>
        </div>
      </div>
      <ModalAlert
        ref={modalAlertCompleteRef}
        title={isSuccess ? '登録完了' : '登録失敗'}
        content={
          isSuccess ? '登録しました。' : 'お時間をおいて再度設定してください。'
        }
        approveFunc={isSuccess ? () => redirectToFunc() : () => {}}
      />
    </React.Fragment>
  );
};

export default Questions;
